import { render, staticRenderFns } from "./activity-add-edit-question.vue?vue&type=template&id=610dc24c&scoped=true&"
import script from "./activity-add-edit-question.vue?vue&type=script&lang=js&"
export * from "./activity-add-edit-question.vue?vue&type=script&lang=js&"
import style0 from "./activity-add-edit-question.vue?vue&type=style&index=0&id=610dc24c&scoped=true&lang=scss&"
import style1 from "./activity-add-edit-question.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610dc24c",
  null
  
)

component.options.__file = "activity-add-edit-question.vue"
export default component.exports